<template>
  <tk-flex
    column
    v-if="inviData"
    style="padding: 10px;background: linear-gradient(283.83deg, #1B1464 -67.54%, #276AFF 116.71%);"
    :style="{width: width * 2 + 'px',height: height * 2 + 'px'}"
  >
    <tk-flex
      column
      style="width: 100%; height: 100%;background: #ffffff;padding: 16Px;position: relative;"
    >
      <tk-flex
        class="full-width"
        center
        middle
        :style="`height: ${width * 2 - 120}px;background: url('${(inviData.inviImg && inviData.inviImg.length && inviData.inviImg[0]) || headBgUrl}') no-repeat center;background-size: cover;`"
      ></tk-flex>
      <tk-flex
        middle
        style="width: 100%;height: 92px;overflow: hidden;margin-top: -24px;padding: 0 34px;flex-shrink: 0;"
      >
        <div
          style="width: 92px;height: 92px;;overflow: hidden;background: transparent;display: flex;align-items: center;justify-content: center;"
        >
          <tk-image
            :width="92"
            :height="92"
            :src="inviData.user.avatar"
            style="border-radius: 48px;overflow: hidden;"
          />
        </div>
        <div
          style="font-size: 28px;margin-left: 16px;white-space: nowrap;overflow: hidden;text-overflow:ellipsis;"
        >{{ inviData.user.nickName === inviData.user.phone ? inviData.user.nickName.replace(/^(\d{3})\d{4}(\d+)/, '$1****$2') : inviData.user.nickName }}</div>
      </tk-flex>
      <tk-flex column around :style="`width: 100%;height: calc(100% - ${width * 2 - 120}px)`">
        <div
          class="poster-text line-clamp-2"
          style="text-align: justify;"
          v-if="inviData.inviContent"
        >{{inviData.inviContent || '' }}</div>
        <div style="width: 100%;height: 2px;background: #eeeeee;" v-if="inviData.inviContent"></div>
        <tk-flex middle around style="width: 100%;">
          <div style="width: 240px;height: 104px;">
            <tk-image
              class="flex-shrink-0"
              :oraign="true"
              :quality="85"
              style="width: 100%;height: 100px;margin-top: 2px;"
              :src="titleImg"
            />
          </div>
          <img :src="qrImage" style="width: 140px;height: 140px;flex-shrink: 0" alt />
        </tk-flex>
      </tk-flex>
    </tk-flex>
  </tk-flex>
</template>
<script>
export default {
  data () {
    return {
      width: 327,
      height: 473,
      getParams: [],
      headBgUrl: require('../../../assets/image/zhituo/headBgUrl.jpg'), // 引入图片
      titleImg: require('../../../assets/image/zhituo/titleImg.png'),
      qrImage: '',
      inviData: {
        inviImg: [],
        user: {
          avatar: '',
          nickName: ''
        }
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    //   // 0 帖子数据id ，1 设备宽， 2设备高
  },
  methods: {
    async init () {
      // this.getParams = String('V4bS6eYcNV,327,473').split(',')
      this.getParams = this.$route.query.params.split(',')
      this.width = this.getParams[1]
      this.height = this.getParams[2]
      await this.getInvi() // 获取帖子数据
    },
    async getInvi () {
      const res = await this.$tkParse.get(`https://cloud.zhituo.mokekeji.com/classes/invitation/${this.getParams[0]}`, { params: { include: 'user' } })
      const res1 = await this.$axios.get(`https://cloud.zhituo.mokekeji.com/wx/getWxacode?id=${this.getParams[0]}`, {
        responseType: 'arraybuffer'
      })
      const base64String = `data:image/jpeg;base64,${window.btoa(String.fromCharCode(...new Uint8Array(res1.data)))}`
      this.qrImage = base64String
      this.inviData = res.data
      this.$forceUpdate()
    }
  }
}
</script>
<style lang="scss" scoped>
.poster-text{
  font-size: 28px;
  margin-top: 24px;
}
// 只显示两行超出隐藏
.line-clamp-2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
